import { Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';
import { Controller, FieldPath, UseFormReturn } from 'react-hook-form';
import { CrawlerReleasedChannel } from '../../../../../constants/crawlerReleasedChannel';

type Props<TFieldValues> = {
  name: FieldPath<TFieldValues>;
  control: UseFormReturn<TFieldValues>['control'];
  isInvalid: boolean;
};

export const ReleasedChannelCheckboxGroup = <TFieldValues,>({
  name,
  control,
  isInvalid,
}: Props<TFieldValues>) => (
  <Controller
    name={name}
    control={control}
    rules={{
      required: '必須項目です。',
    }}
    render={({ field: { ref: _, value, ...rest } }) => (
      <CheckboxGroup value={value as CrawlerReleasedChannel[]} {...rest}>
        <Stack spacing={8} direction="row">
          <Checkbox value="stable" isInvalid={isInvalid}>
            安定版
          </Checkbox>
          <Checkbox value="beta" isInvalid={isInvalid}>
            ベータ版
          </Checkbox>
        </Stack>
      </CheckboxGroup>
    )}
  />
);
